var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 2.5C8.84437 2.5 6.93672 3.29018 5.53019 4.6967C4.12367 6.10322 3.3335 8.01088 3.3335 10H0.833496L4.07516 13.2417L4.1335 13.3583L7.50016 10H5.00016C5.00016 8.4529 5.61474 6.96917 6.70871 5.87521C7.80267 4.78125 9.2864 4.16667 10.8335 4.16667C12.3806 4.16667 13.8643 4.78125 14.9583 5.87521C16.0522 6.96917 16.6668 8.4529 16.6668 10C16.6668 11.5471 16.0522 13.0308 14.9583 14.1248C13.8643 15.2188 12.3806 15.8333 10.8335 15.8333C9.22516 15.8333 7.76683 15.175 6.71683 14.1167L5.5335 15.3C6.2265 16.0004 7.05211 16.5556 7.9621 16.9334C8.87209 17.3111 9.84823 17.5037 10.8335 17.5C12.8226 17.5 14.7303 16.7098 16.1368 15.3033C17.5433 13.8968 18.3335 11.9891 18.3335 10C18.3335 8.01088 17.5433 6.10322 16.1368 4.6967C14.7303 3.29018 12.8226 2.5 10.8335 2.5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.270f4a059f5d88b794e85e0adbdf35b4.svg";
export { ForwardRef as ReactComponent };